import data from "../../json/eye-conditions.json";
import { clickEvent, setEyeConditionEvent } from "../utils/Events";
import eyeConditionsData from "../../json/eye-conditions.json";
import { openDownloadPage } from "./DownloadPage";
import Analytics from "../utils/Analytics";
const eyeConditions = data["eye-conditions"];
const inGameUI = document.querySelector(".ui");

const homepageElement = inGameUI?.querySelector("#homepage");

const main = inGameUI?.querySelector("#main") as HTMLElement;
const eyeConditionsContainer = main?.querySelector(".eye-conditions-container");

const severityScaleContainer = main?.querySelector(".severity-scale-container");
const severityScaleHeader = severityScaleContainer?.querySelector<HTMLElement>(
  ".severity-scale__header",
);
const severityScaleFooter = severityScaleContainer?.querySelector(
  ".severity-scale__footer",
);

const floatingSeverityScaleButtons =
  inGameUI?.querySelectorAll<HTMLButtonElement>(
    "#floating-severity-scale button",
  );
const colorBlindnessGrid = severityScaleContainer?.querySelector(
  ".color-blindness-grid",
);
const severityScale = severityScaleContainer?.querySelector(
  ".severity-scale",
) as HTMLElement;
const severityScaleButtons = severityScale?.querySelectorAll("button");
const floatingSeverityScale = inGameUI?.querySelector(
  "#floating-severity-scale",
);
const eyeConditionsGrid = main?.querySelector(
  ".eye-conditions-grid",
) as HTMLElement;

const toolTip = <HTMLButtonElement>main?.querySelector("#tooltip-main-button");
const toolTipExpandButton = main?.querySelector("#tooltip-expand-button");
const rnibInformation = main?.querySelector(".rnib-expanded-info");
const rnibInformationInner = main?.querySelector(".rnib-expanded-info span");
const severityScaleToolTip = main?.querySelector("#severity-scale-tooltip");

const homeButton = main?.querySelector("#main-ui-home-button");
const collapseButton = main?.querySelector("#tooltip-collapse-button");

const eyeConditionButton = main?.querySelector("#main-ui-eye-condition-button");
const prevButton = main?.querySelector(".navigation--arrow.left");
const nextButton = main?.querySelector(".navigation--arrow.right");
const homeButtonContainer = <HTMLElement>(
  document?.querySelector(".home__button-container")
);

const externalLinkConfirmButton = document?.querySelector(
  ".external-site-confirm-button",
);
const externalSite = <HTMLElement>document?.querySelector("#external-site");
const ui = <HTMLElement>document?.querySelector(".ui");

const findOutMoreButton = main?.querySelector("#find-out-more-button");

findOutMoreButton?.addEventListener("click", () => {
  externalLinkConfirmButton?.setAttribute(
    "data-href",
    "https://www.rnib.org.uk/campaign-with-us/beforeyouask/what-you-can-do-to-help/",
  );
  externalLinkConfirmButton!.id = "external-site-confirm-find-more";
  externalSite.style.display = "flex";
  ui.style.display = "none";
});

let buttonPages: Array<HTMLElement> = [];
let currentPage = 0;

let conditionsViewed = 0;
let downloadPageOpened = false;

/* Functions */

const clearButtonContainer = () => {
  homeButton?.classList.add("hidden");
  eyeConditionButton?.classList.add("hidden");
  floatingSeverityScale?.classList.remove("ar-mode");
};

const updateSeverityScalesButtonsIds = (condition: string) => {
  severityScaleButtons.forEach(
    (button) =>
      (button.id = `${condition}-severity-level-${button.dataset.severity}`),
  );
  floatingSeverityScaleButtons!.forEach(
    (button) =>
      (button.id = `${condition}-severity-level-${button.dataset.severity}`),
  );
};

const generateEyeConditionButtons = async () => {
  if (!eyeConditionsGrid) return;

  eyeConditions?.forEach((eyeCondition, index: number) => {
    const buttonElement = document.createElement("button");

    buttonElement.ariaLabel =
      eyeCondition.tagName +
      ", scrollable grid" +
      (index + 1) +
      "of " +
      eyeConditions.length;
    //buttonElement.setAttribute("aria-describedby", "tooltip-main-button");

    buttonElement.setAttribute("data-type", eyeCondition.name);
    buttonElement.setAttribute("data-id", `${index}`);
    buttonElement.classList.add("cta");
    if (eyeCondition.hidden) buttonElement.classList.add("hidden");

    buttonElement.innerHTML = eyeCondition.tagName;

    buttonElement?.addEventListener("click", () => {
      if (homeButtonContainer != null) {
        homeButtonContainer.classList.remove("alignStart");
      }
      if (severityScaleToolTip) {
        severityScaleToolTip.innerHTML = eyeCondition.tagName.toUpperCase();
      }

      if (!downloadPageOpened) conditionsViewed++;

      const eyeConditionType = buttonElement.dataset.type;
      if (!eyeConditionType || !toolTip) return;

      findOutMoreButton?.classList.add("hidden");
      eyeConditionButton?.classList.remove("hidden");
      
      updateSeverityScalesButtonsIds(eyeConditionType);

      if (eyeConditionType === "color-blindness") {
        eyeConditionsContainer?.classList.add("hidden");
        colorBlindnessGrid?.classList.remove("hidden");
        severityScale?.classList.add("hidden");
        severityScaleHeader?.classList.add("hidden");
        severityScaleFooter?.classList.add("hidden");
        severityScale.removeAttribute("data-eye-condition");
        severityScaleContainer?.classList.remove("hidden");
        toolTip?.classList.add("unclickable");
        toolTip?.classList.add("hidden");
      } else if (
        eyeConditionType === "none" ||
        eyeConditionType === "hemianopia"
      ) {
        setEyeConditionEvent(eyeConditionType, 3);
        eyeConditionsContainer?.classList.add("hidden");
        colorBlindnessGrid?.classList.add("hidden");
        severityScaleContainer?.classList.add("hidden");
        main?.classList.add("space-between");
        //floatingSeverityScale?.classList.add("ar-mode");
        if (eyeConditionType === "none") {
          toolTip.innerHTML = "20/20 VISION";
          toolTip.classList.add("unclickable");
        } else {
          toolTip?.classList.remove("unclickable");
        }
      } else {
        eyeConditionsContainer?.classList.add("hidden");
        colorBlindnessGrid?.classList.add("hidden");
        severityScale?.classList.remove("hidden");
        severityScaleContainer?.classList.remove("hidden");
        severityScaleHeader?.classList.remove("hidden");
        severityScaleFooter?.classList.remove("hidden");
        severityScale.setAttribute("data-eye-condition", eyeConditionType);
        toolTip?.classList.add("hidden");
        toolTip?.classList.remove("unclickable");
      }
    });

    eyeConditionsGrid?.appendChild(buttonElement);
  });

  const colorBlindnessList = eyeConditions.find(
    (object) => object.tagName === "Colour Blindness",
  );

  const colorBlindnessOptions = colorBlindnessList?.options;

  if (colorBlindnessOptions) {
    colorBlindnessOptions.forEach((option, index) => {
      const buttonElement = document.createElement("button");
      buttonElement.ariaLabel =
        option.tagName +
        ", grid" +
        (index + 1) +
        "of " +
        colorBlindnessOptions.length;
      buttonElement.setAttribute("aria-describedby", "severity-scale-tooltip");

      buttonElement.setAttribute("data-type", option.tagName);
      buttonElement.setAttribute("data-info", option.desc);
      buttonElement.setAttribute("data-id", `${index}`);
      buttonElement.classList.add("cta");

      buttonElement.innerHTML = option.tagName;

      buttonElement.addEventListener("click", () => {
        if (toolTip && rnibInformationInner) {
          resetTooltip();

          //floatingSeverityScale?.classList.add("ar-mode");
          toolTip.classList.remove("unclickable");
          toolTip.innerHTML = option.name;
          rnibInformationInner.innerHTML = option.desc;
          toolTip.classList.remove("hidden");
        }

        main?.classList.add("space-between");
        severityScaleContainer?.classList.add("hidden");
        setEyeConditionEvent(option.tagName, 5);
      });
      colorBlindnessGrid?.appendChild(buttonElement);
    });
  }

  const pagesLength = Math.ceil(eyeConditions.length / 6);
  if (pagesLength < 2) return eyeConditionsGrid;

  // Pagination
  for (let j = 0; j < pagesLength; j++) {
    const page = document.createElement("div");
    for (let i = 0; i < 6; i++) {
      if (eyeConditionsGrid.children[0]) {
        page.appendChild(eyeConditionsGrid.children[0]);
      }
    }
    buttonPages.push(page);
  }

  buttonPages.forEach((page) => {
    eyeConditionsGrid.appendChild(page);
  });

  return eyeConditionsGrid;
};

const resetTooltip = () => {
  if (!toolTip || !rnibInformation || !rnibInformationInner) return;
  // Reset Tooltip
  toolTip.classList.remove("hidden");
  toolTip.classList.add("unclickable");
  toolTip.innerHTML = "Scroll down for more<br/>eye conditions";
  rnibInformation.classList.add("hidden");
  toolTip.classList.remove("expanded-info");
  rnibInformationInner.innerHTML = "";
  main?.classList.remove("space-between");
};

/* Export */

export const Main = () => {
  generateEyeConditionButtons().then(() => {
    floatingSeverityScaleButtons?.forEach((severityScaleButton) => {
      severityScaleButton?.addEventListener("click", () => {
        floatingSeverityScaleButtons?.forEach((severityScaleButton) => {
          severityScaleButton.classList.remove("selected");
          if (severityScaleButton.ariaLabel) {
            severityScaleButton.ariaLabel =
              severityScaleButton.ariaLabel.replace("; selected", "");
          }
        });

        severityScaleButton.classList.add("selected");
        severityScaleButton.ariaLabel += "; selected";

        const eyeConditionData = severityScale?.dataset.eyeCondition;
        const severityLevelData = Number(severityScaleButton.dataset.severity);

        if (!eyeConditionData || !severityLevelData) return;

        setEyeConditionEvent(eyeConditionData, severityLevelData);
      });
    });

    severityScaleButtons?.forEach((severityScaleButton) => {
      severityScaleButton?.addEventListener("click", () => {
        const eyeConditionData = severityScale?.dataset.eyeCondition;
        const severityLevelData = Number(severityScaleButton.dataset.severity);

        floatingSeverityScaleButtons?.forEach((severityScaleButton, index) => {
          severityScaleButton.classList.remove("selected");
          if (severityScaleButton.ariaLabel) {
            severityScaleButton.ariaLabel =
              severityScaleButton.ariaLabel.replace("; selected", "");
          }

          if (index == severityLevelData - 1) {
            severityScaleButton.classList.add("selected");
            severityScaleButton.ariaLabel += "; selected";
          }
        });

        if (!eyeConditionData || !severityLevelData) return;

        severityScaleContainer?.classList.add("hidden");
        main?.classList.add("space-between");

        setEyeConditionEvent(eyeConditionData, severityLevelData);
        floatingSeverityScale?.classList.add("ar-mode");
        severityScaleHeader?.focus();
        toolTip?.classList.remove("hidden");
      });
    });

    if (inGameUI && prevButton && nextButton) {
      setTimeout(
        () =>
          document
            .querySelectorAll<HTMLElement>(".eye-conditions-grid > div")
            .forEach((page) => {
              page.style.width = `${inGameUI?.clientWidth - 80}px`;
            }),
        300,
      );
    }
  });

  window.addEventListener("resize", () => {
    if (inGameUI && prevButton && nextButton) {
      setTimeout(
        () =>
          buttonPages.forEach((page) => {
            page.style.width = `${inGameUI?.clientWidth - 80}px`;
          }),
        300,
      );
    }
  });

  prevButton?.addEventListener("click", () => {
    if (currentPage > 0) {
      currentPage--;
      eyeConditionsGrid.scrollTo({
        //behavior: orientation === "portrait" ? "smooth" : "auto",
        behavior: "smooth",
        left: buttonPages[currentPage].clientWidth * currentPage,
      });
    }
    // onPageUpdate();
  });

  nextButton?.addEventListener("click", () => {
    if (currentPage + 1 < buttonPages.length) {
      currentPage++;
      eyeConditionsGrid.scrollTo({
        behavior: "smooth",
        left: buttonPages[currentPage].clientWidth * currentPage,
      });
    }
  });

  eyeConditionButton?.addEventListener("click", () => {
    if (homeButtonContainer != null) {
      homeButtonContainer.classList.add("alignStart");
    }
    
    setEyeConditionEvent("none", 1);
    clearButtonContainer();
    homeButton?.classList.remove("hidden");

    findOutMoreButton?.classList.remove("hidden");

    eyeConditionsContainer?.classList.remove("hidden");
    severityScaleContainer?.classList.add("hidden");
    resetTooltip();
  });

  collapseButton?.addEventListener("click", () => {
    toolTip?.classList.remove("expanded-info");
    rnibInformation?.classList.add("hidden");
    if (!main.classList.contains("space-between")) {
      severityScaleContainer?.classList.remove("hidden");
    }
  });

  toolTip?.addEventListener("click", () => {
    toggleTooltip();
  });

  toolTipExpandButton?.addEventListener("click", () => {
    toggleTooltip();
  });

  const toggleTooltip = () => {
    if (!rnibInformation || !toolTip) return;

    if (!toolTip.classList.contains("unclickable")) {
      if (toolTip.classList.contains("expanded-info")) {
        toolTip.classList.remove("expanded-info");
        rnibInformation.classList.add("hidden");
        // severityScaleContainer?.classList.remove("hidden");

        Analytics.pushEvent({
          event: "page_view",
          parameter: "close_condition_info",
          parameterValue: ""
        });

      } else {
        toolTip.classList.add("expanded-info");
        rnibInformation.classList.remove("hidden");

        Analytics.pushEvent({
          event: "page_view",
          parameter: "view_condition_info",
          parameterValue: ""
        });
        // severityScaleContainer?.classList.add("hidden");
      }
    }
  };

  document.addEventListener("rnib:condition", (e: CustomEventInit) => {
    const currenteyecondition = e.detail.condition;
    if (!currenteyecondition || currenteyecondition === "none") return;
    const givenEyeCondition = eyeConditionsData["eye-conditions"].find(
      (eyeconditiondata) => eyeconditiondata.name === currenteyecondition,
    );

    if (
      rnibInformationInner &&
      toolTip &&
      currenteyecondition &&
      givenEyeCondition &&
      severityScaleToolTip
    ) {
      toolTip.innerHTML = givenEyeCondition.tagName.toUpperCase();
      severityScaleToolTip.innerHTML = givenEyeCondition.tagName.toUpperCase();
      rnibInformationInner.innerHTML = givenEyeCondition.desc;
      toolTip.dispatchEvent(clickEvent);
    }
  });
};

export default Main;
